/**
 * 用css设置rem
 * @param remUnit 每rem等于多少屏幕宽度
 */
export function setupRem() {
  var remUnit = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 37.5;
  document.documentElement.style.fontSize = 375 / remUnit + 'vw';
}